import React from 'react';
import {FormattedMessage} from "react-intl";

import {GlobalHeaderButtons} from "../PageLayout/GlobalHeaderButtons";

const AgentPageHeader = () => {
  return (
    <div className="app-header app-header-adj">
      <GlobalHeaderButtons/>
      <div className="lightbox-header-container">
        <div className="lightbox-title-block">
          <h1 id="PageTitle">
            <FormattedMessage id="centralHub.buttons.agent"/>
          </h1>
        </div>
      </div>
    </div>
  )
};

export default AgentPageHeader
